import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/transferenciasestado/listar/form_edit'
import Head from '../../../../components/head'


function EditarTransferenciasScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Transferência" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarTransferenciasScreen;